
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.4 4H8.9c-.7 0-1.2.2-1.7.7-.5.5-.7 1-.7 1.7v19.2c0 .7.2 1.2.7 1.7s1 .7 1.7.7h14.2c.6 0 1.2-.2 1.7-.7s.7-1 .7-1.7V11.2L18.4 4zm-1.2 8.4V5.8l6.6 6.6h-6.6z"}})])
          )
        }
      }
    